// extracted by mini-css-extract-plugin
export default {"card":"ActionList_card__iHDwN","actionTitle":"ActionList_actionTitle__sILf8","actionCard":"ActionList_actionCard__nk4y3"};